import React, { ReactNode, useEffect, useState } from 'react';
import DashboardLayout from '../../../../../layout/dashboard/dashboardLayout';
import PageLayout from '../../../../../layout/dashboard/tableLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import UserDetailsInfo from './UserDetailsInfo';
import verified from '../../../../../assets/images/verified_m.png';
import '../newsingleuser/styles/Index.css';
import SingleMerchantTabLink from './components/SingleMerchantTabLink';
import { ALL_ROUTES } from '../../../../../routes/dashboard/overview/AllPathNames';
import RootState, {
	AssignBankBoxPayload,
	BankBoxUser,
	SettlementChangeRequest,
} from '../../../../../redux/types';
import {
	RavenActionBar,
	RavenInputField,
	RavenModal,
	RavenToggleSlide,
	RavenToolTip,
	RavenUseOnClickOutside,
	RavenValidateData,
	toast,
} from '@ravenpay/raven-bank-ui';
import { useDispatch, useSelector } from 'react-redux';
import { bankboxAPI } from '../../../../../redux/bankbox';
import {
	getActionNamesByPolicyName,
	reactSelectStyle,
	removeSpace,
	validateStringForTerminalId,
} from '../../../../../utils/helper/Helper';
import CameraAssignBox from '../cameraAssign/CameraAssignBox';
import { icons, illustrations } from '../../../../../assets/icons';
import SettleMentAccountModal from '../component/SettleMentAccountModal';
import UpdateMerchantFeeUserModal from '../../components/modals/UpdateFeeMerchantModal';
import UpdateBankboxUserModal from '../../components/modals/UpdateBankboxUserModal';
import ProccessSettleMentAccountModal from '../component/ProcessSettlementMerchant';
import ActionModal from '../../../../../components/common/modal/ActionModal';
import InlineDetails from '../../../../../components/common/inlineDetails';
import ReqAccountModal from './components/modal/reqAccountModal';
import { fetchSettlementRequest } from '../../../../../redux/settlement';
import dayjs from 'dayjs';
import { useDarkMode } from '../../../../../hooks/useDarkMode';
import EditUserOptionModal from '../component/EditUserOptionModal';
import BusinessRequestChangeModal from '../component/BusinessRequestDetailsModal';
import { ThreeDots } from 'react-loader-spinner';

interface SingleUserLayoutProps {
	children?: React.ReactNode;
	childrenModal?: React.ReactNode;
	btnContent?: React.ReactNode;
	modalContent?: React.ReactNode;
	tabLink?: React.ReactNode;
	activeTabIndex?: string;
	actionBarComp?: React.ReactNode;
	setActiveTabIndex?: (param?: any) => void;
}

const userDetails = {
	logo: verified,
	businessName: 'Nathaniel and Sons LTD',
	ownerName: 'Adeeko Emmanuel',
	email: 'emmy4su.web@gmail.com',
	dateJoined: '26, October 2021',
	bvn: '567654323456',
	nin: '567654323456',
	category: 'Financial Technology',
	region: 'Lagos State',
	address: '10, Oyedele Close, Lagos State',
	description: 'Deals in Importing and Exporting Goods.',
	walletBalance: '₦45,533,584.00',
	lien: '₦0.00',
};

const SingleUserLayout: React.FC<SingleUserLayoutProps> = ({
	children,
	childrenModal,
	activeTabIndex,
	setActiveTabIndex,
	modalContent,
}) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [showSettlement, setShowSettlement] = useState<boolean>(false);
	const [editMerchantFeeModal, setEditMerchantFeeModal] =
		useState<boolean>(false);
	const [showModal, setIsShowModal] = useState({
		edit_option: false,
		edit_personal: false,
		edit_business: false,
		fee: false,
		business_request: false,
	});
	const [isRefreshing, setIsRefreshing] = useState(false);
	const {
		loading,
		user_merchant,
		all_states,
		all_lga,
		settlement_detail_req,
		user_merchant_settlement,
	} = useSelector((state: RootState) => state.bankbox);

	const dispatch = useDispatch();

	const infoIcon = (
		<svg
			className="img"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_164_20412)">
				<path
					d="M7.99967 10.6668V8.00016M7.99967 5.3335H8.00634M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z"
					stroke="black"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_164_20412">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
	const cameraIcon = (
		<svg
			className="img"
			width="18"
			height="19"
			viewBox="0 0 18 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_16594_47752)">
				<path
					d="M5.97578 16.0249V5.64153C5.97578 4.9518 5.97578 4.60694 6.05209 4.32399C6.25917 3.55616 6.86282 2.95642 7.63564 2.75068C7.92043 2.67487 8.26754 2.67487 8.96176 2.67487C9.65597 2.67487 10.0031 2.67487 10.2879 2.75068C11.0607 2.95642 11.6643 3.55616 11.8714 4.32399C11.9477 4.60694 11.9477 4.9518 11.9477 5.64153V10.4624M11.9477 13.429V16.0249M5.07999 16.0249H12.8435C14.0977 16.0249 14.7249 16.0249 15.2039 15.7824C15.6253 15.569 15.9679 15.2287 16.1826 14.81C16.4267 14.334 16.4267 13.711 16.4267 12.4649V9.20153C16.4267 7.95542 16.4267 7.33236 16.1826 6.8564C15.9679 6.43774 15.6253 6.09736 15.2039 5.88404C14.7249 5.64153 14.0977 5.64153 12.8435 5.64153H5.07999C3.82577 5.64153 3.19865 5.64153 2.7196 5.88404C2.29822 6.09736 1.95562 6.43774 1.74091 6.8564C1.49683 7.33236 1.49683 7.95542 1.49683 9.20153V12.4649C1.49683 13.711 1.49683 14.334 1.74091 14.81C1.95562 15.2287 2.29822 15.569 2.7196 15.7824C3.19865 16.0249 3.82577 16.0249 5.07999 16.0249ZM9.55895 13.429H13.2168C13.4258 13.429 13.5303 13.429 13.6102 13.3886C13.6804 13.3531 13.7375 13.2963 13.7733 13.2266C13.814 13.1472 13.814 13.0434 13.814 12.8357V11.0557C13.814 10.848 13.814 10.7442 13.7733 10.6648C13.7375 10.5951 13.6804 10.5383 13.6102 10.5028C13.5303 10.4624 13.4258 10.4624 13.2168 10.4624H9.55895C9.34991 10.4624 9.24539 10.4624 9.16555 10.5028C9.09532 10.5383 9.03822 10.5951 9.00244 10.6648C8.96176 10.7442 8.96176 10.848 8.96176 11.0557V12.8357C8.96176 13.0434 8.96176 13.1472 9.00244 13.2266C9.03822 13.2963 9.09532 13.3531 9.16555 13.3886C9.24539 13.429 9.34991 13.429 9.55895 13.429Z"
					stroke="black"
					strokeWidth="1.335"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_16594_47752">
					<rect
						width="17.9158"
						height="17.8"
						fill="white"
						transform="translate(0.00390625 0.44986)"
					/>
				</clipPath>
			</defs>
		</svg>
	);

	// const [activeTabIndex, setActiveTabIndex] = useState<string>(
	// 	ALL_ROUTES?.SINGLE_TRANSACTION
	// );
	const deviceTypeOption = [
		{ label: 'BankBox', value: 'bankbox' },
		{ label: 'BankBox PinPad', value: 'bankbox_pinpad' },
		{ label: 'Virtual Terminal', value: 'virtual_terminal' },
	];
	const [assignFormData, setAssignFormData] = useState<AssignBankBoxPayload>({
		poseidon_business_email: '',
		serial_number: '',
		label: '',
		poseidon_business_name: '',
		exist_nibbs: true,
		auto_generate: true,
		is_nibss: true,
		terminal_id: '',
		device_type: '',
		purpose: '',
		account_num: '',
	});
	const [currentPage, setCurrentPage] = useState(1);
	const [uploadViaCamera, setUploadViaCamera] = useState(false);
	const [requestSettleMerchantModal, setRequestSettleMerchantModal] =
		useState<boolean>(false);
	const [terminalDetails, setTerminalDetails] = useState<any>({});
	const [selectedType, setSelectedType] = useState('Yes, It is');
	const selectTypeList = ['Yes, It is', 'No, it’s not'];
	const [assignBankbox, setAssignBankbox] = useState<{
		on: boolean;
		chi: BankBoxUser;
	}>({
		on: false,
		chi: {
			id: 0,
			fname: '',
			lname: '',
			poseidon_email: '',
			bvn: '',
			nin: '',
			phone: '',
			affiliate_app: '',
			affiliate_app_id: '',
			poseidon_business_name: '',
			poseidon_business_address: '',
			poseidon_business_type: null,
			poseidon_business_description: '',
			poseidon_profile_reference: '',
			business_category: '',
			region: '',
			created_at: '',
			updated_at: '',
			lga: '',
		},
	});

	interface formComponent {
		state: any;
		lga: any;
	}
	const [details, setDetails] = useState<formComponent>({
		state: '',
		lga: '',
	});

	type ChiType = {
		id?: number;
		bvn?: string;
		email?: string;
		full_name?: string;
		phone?: string;
		address?: string;
		dob?: string;
		bvn_verified_at?: string;
		poseidon_email?: string;
		nin?: string;
		affiliate_app?: string;
		affiliate_app_id?: string;
		business_name?: string;
		state?: string;
		lga?: string;
		type?: string;
		status?: number;
		business_address?: string;
		address_verified_at?: string;
		date_authorized?: string;
		// Add any other required properties from BankBoxUser
	};

	const [view, setView] = useState<{ on: boolean; chi: ChiType | null }>({
		on: false,
		chi: null,
	});
	const { profile } = useSelector((state: RootState) => state.settings);
	const [theme, toggleTheme] = useDarkMode(localStorage.getItem('theme'));
	const [singleChild, setSingleChild] = useState<any>({});
	const [editMerchantModal, setEditMerchantModal] = useState<boolean>(false);
	const [showTerminalError, setShowTerminalError] = useState(false);
	const [autoAssign, setAutoAssign] = useState(true);
	const [showActionBarinfo, setShowActionBarinfo] = useState(false);

	const [showActionBar, setShowActionBar] = useState(false);

	// useEffect(() => {
	// 	if (!request?.data?.date_requested) return;

	// 	const changeDate = dayjs(request?.data?.date_requested);
	// 	const sevenDaysAgo = dayjs().subtract(7, 'day');

	// 	const isWithin7Days = changeDate.isAfter(sevenDaysAgo);
	// 	setShowActionBarinfo(isWithin7Days);
	// }, [request]);

	useEffect(() => {
		getFirstFetch();
	}, []);

	useEffect(() => {
		if (Object.keys(all_states)?.length < 1) {
			dispatch(bankboxAPI.getBankboxStates({}));
		}
	}, []);

	const getFirstFetch = async () => {
		dispatch(
			bankboxAPI.getAllFeesWithoutPagination({
				per_page: 20,
				page: currentPage,
				// affiliate_app_id:
			})
		);
	};

	async function handleAssign() {
		if (
			!validateStringForTerminalId(assignFormData?.terminal_id) &&
			!autoAssign &&
			assignFormData?.device_type?.value !== 'virtual_terminal'
		) {
			toast.error(
				'Terminal ID must be exactly 8 characters, all capitalized and alphanumeric.'
			);
			setShowTerminalError(true);
			return;
		}
		const obj = {
			...assignFormData,
			auto_generate: autoAssign,
			is_nibss: autoAssign ? false : assignFormData?.exist_nibbs,
			terminal_id: assignFormData?.terminal_id,
			state: details?.state?.value,
			city: details?.lga,
			poseidon_business_name: user_merchant?.user?.poseidon_business_name,
			poseidon_business_email: user_merchant?.user?.poseidon_email,
			device_type: assignFormData?.device_type?.value,
		};
		// //(obj);

		if (assignFormData?.device_type?.value === 'virtual_terminal') {
			const val = {
				label: assignFormData?.label,
				merchant_email: user_merchant?.user?.poseidon_email,
				account_number: assignFormData?.account_num,
				purpose: assignFormData?.purpose?.value,
			};
			// console.log(val);
			// return;

			const resp = await dispatch(bankboxAPI.assignBankboxVirtual(val));

			if (resp.payload?.status === 'success') {
				setAssignBankbox({
					...assignBankbox,
					on: false,
				});
				const objTwo = {
					email: merchant_email,
				};
				dispatch(bankboxAPI?.getVirtualBankBoxForMerchant(objTwo));
				setAssignFormData({
					poseidon_business_email: '',
					serial_number: '',
					label: '',
					poseidon_business_name: '',
					exist_nibbs: true,
					auto_generate: true,
					is_nibss: true,
					terminal_id: '',
					device_type: '',
					purpose: '',
					account_num: '',
				});
			}
		} else {
			const resp = await dispatch(bankboxAPI.assignBankbox(obj));

			if (resp.payload?.status === 'success') {
				setAssignBankbox({
					...assignBankbox,
					on: false,
				});
				getFirstFetch();
				setAssignFormData({
					poseidon_business_email: '',
					serial_number: '',
					label: '',
					poseidon_business_name: '',
					exist_nibbs: true,
					auto_generate: true,
					is_nibss: true,
					terminal_id: '',
					device_type: '',
					purpose: '',
					account_num: '',
				});
			}
		}
	}
	const [el, setEl] = React.useState<any>({
		id: 0,
		fname: '',
		lname: '',
		poseidon_email: '',
		bvn: '',
		nin: '',
		phone: '',
		affiliate_app: '',
		affiliate_app_id: '',
		poseidon_business_name: '',
		poseidon_business_address: '',
		poseidon_business_type: null,
		poseidon_business_description: '',
		poseidon_profile_reference: '',
		business_category: '',
		region: '',
		created_at: '',
		updated_at: '',
		ref_fee: '',
	});
	React.useEffect(() => {
		setEl(user_merchant?.user);
	}, [user_merchant]);

	const merchant_email = localStorage?.getItem('merchant-email-user-preview');
	const [refreshTable, setRefreshTable] = useState(false);
	useEffect(() => {
		if (merchant_email) {
			// coming back here with user_merchant
			getSingleDetails();
			// dispatch(fetchSettlementRequest(merchant_email));
		} else {
			navigate(ALL_ROUTES?.BANKBOX_USER);
		}
	}, [dispatch, refreshTable]);

	const formatState = (param: any) => {
		if (param?.length > 0) {
			const newList = param?.map((chi: any) => {
				return { label: chi, value: chi };
			});
			return newList;
		}
	};

	const loading_reciept = false;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [showManagedropdown, setShowManageDropDown] = useState(false);

	const testingFilterFragRef = RavenUseOnClickOutside(() => {
		setShowDrop(false);
	});

	const editIcon = (
		<svg
			className="img"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 18.0002L19.9999 19.0943C19.4695 19.6744 18.7501 20.0002 18.0001 20.0002C17.2501 20.0002 16.5308 19.6744 16.0004 19.0943C15.4692 18.5154 14.75 18.1903 14.0002 18.1903C13.2504 18.1903 12.5311 18.5154 12 19.0943M3 20.0002H4.67454C5.16372 20.0002 5.40832 20.0002 5.63849 19.945C5.84256 19.896 6.03765 19.8152 6.2166 19.7055C6.41843 19.5818 6.59138 19.4089 6.93729 19.063L19.5 6.50023C20.3285 5.6718 20.3285 4.32865 19.5 3.50023C18.6716 2.6718 17.3285 2.6718 16.5 3.50023L3.93726 16.063C3.59136 16.4089 3.4184 16.5818 3.29472 16.7837C3.18506 16.9626 3.10425 17.1577 3.05526 17.3618C3 17.5919 3 17.8365 3 18.3257V20.0002Z"
				stroke={theme === 'light' ? `rgba(139, 139, 139, 1)` : `#ffffff`}
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	const arrowIcon = (
		<svg
			className="img"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				// className="dull-bright-filter"
				d="M6 18L18 6M18 6H10M18 6V14"
				stroke={theme === 'light' ? `rgba(139, 139, 139, 1)` : `#ffffff`}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	const feeIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				stroke={theme === 'light' ? `rgba(139, 139, 139, 1)` : `#ffffff`}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
				d="M15.938 15.938A7.001 7.001 0 0 0 15 2a7 7 0 0 0-6.938 6.062M7.5 13 9 12v5.5m-1.5 0h3M16 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
			></path>
		</svg>
	);

	const settlementIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				stroke={theme === 'light' ? `rgba(139, 139, 139, 1)` : `#ffffff`}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
				d="M5 9v8m4.5-8v8m5-8v8M19 9v8M3 18.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.24 21 19.96 21 19.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 17 19.96 17 19.4 17H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.76 3 18.04 3 18.6m8.653-15.523-7.4 1.645c-.447.099-.67.149-.838.269a1 1 0 0 0-.334.417C3 5.597 3 5.826 3 6.283V7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 9 4.04 9 4.6 9h14.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.24 21 7.96 21 7.4V6.283c0-.457 0-.686-.081-.875a1 1 0 0 0-.335-.417c-.166-.12-.39-.17-.837-.27l-7.4-1.644a2 2 0 0 0-.26-.049 1 1 0 0 0-.174 0c-.066.006-.13.02-.26.05"
			></path>
		</svg>
	);

	const assignIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			className="img"
			viewBox="0 0 24 24"
		>
			<path
				stroke={theme === 'light' ? 'rgba(139, 139, 139, 1)' : '#fff'}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
				d="M6 10h.01M8 14h.01M10 10h.01M12 14h.01M14 10h.01M16 14h.01M18 10h.01M5.2 18h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V9.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 6 19.92 6 18.8 6H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 7.52 2 8.08 2 9.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 18 4.08 18 5.2 18"
			></path>
		</svg>
	);
	const [showActionEditRequest, setShowActionEditRequest] = useState(true);
	const [showDrop, setShowDrop] = useState(false);
	const actionList = [
		{
			icon: editIcon,
			name: 'Edit Merchant',
			onClick: () => {
				setSingleChild && setSingleChild(el);
				setIsShowModal((prev: any) => {
					return { ...prev, edit_option: true };
				});
			},
			hide: !getActionNamesByPolicyName(
				profile?.rolePolicies?.policies,
				'merchants'
			)?.includes('edit_merchant'),
		},
		{
			icon: assignIcon,
			name: ' Assign Terminal',
			onClick: () => {
				setAssignBankbox &&
					setAssignBankbox({
						...assignBankbox,
						on: true,
					});
			},
			hide: getActionNamesByPolicyName(
				profile?.rolePolicies?.policies,
				'terminals'
			)?.includes('assign_terminal')
				? false
				: true,
		},
		{
			icon: feeIcon,
			name: 'Manage  Fee Details',
			onClick: () => {
				setEditMerchantFeeModal(true);
			},
			hide: getActionNamesByPolicyName(
				profile?.rolePolicies?.policies,
				'fee details'
			)?.includes('change_fees')
				? false
				: true,
		},

		{
			hide:
				getActionNamesByPolicyName(
					profile?.rolePolicies?.policies,
					'settlement'
				)?.includes('add_merchant_settlement_account') ||
				getActionNamesByPolicyName(
					profile?.rolePolicies?.policies,
					'settlement'
				)?.includes('edit_merchant_settlement_account')
					? false
					: true,
			icon: settlementIcon,
			name: 'Manage Settlement Details',
			onClick: () => {
				setShowSettlement(true);
			},
		},
		{
			icon: arrowIcon,
			name: 'Request Settlement ',
			onClick: (param?: any) => {
				setRequestSettleMerchantModal && setRequestSettleMerchantModal(true);
				// setShowDrop(false);
			},
			hide: Object?.keys(user_merchant_settlement)?.length < 1 ? true : false,
		},
	];
	const [feeDetail, setFeeDetail] = useState<any>({});
	const [singleChildFee, setSingleChildFee] = useState<any>({});
	const getSingleDetails = async () => {
		const data = await dispatch(
			bankboxAPI.getSingleUserMerchant({ email: merchant_email as string })
		);
		// //(data);
		if (data?.payload?.status === 'success') {
			const objFee = data?.payload?.data?.data?.fees;
			const user = data?.payload?.data?.data?.user;
			// //(data?.payload?.data?.data);

			const newObj = { ...user, fee_ref: objFee?.id };
			// //(newObj);
			setSingleChildFee(newObj);
			setFeeDetail(objFee);
		}
	};

	const settingsIcon = (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="img"
		>
			<g clipPath="url(#clip0_1897_11864)">
				<path
					d="M7.81169 10.4997C8.8903 10.4997 9.76468 9.60424 9.76468 8.49967C9.76468 7.39511 8.8903 6.49967 7.81169 6.49967C6.73309 6.49967 5.85871 7.39511 5.85871 8.49967C5.85871 9.60424 6.73309 10.4997 7.81169 10.4997Z"
					stroke="#646464"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="dull-bright-filter"
				/>
				<path
					d="M12.1911 10.3179C12.1123 10.5007 12.0888 10.7034 12.1236 10.9C12.1584 11.0966 12.25 11.2781 12.3864 11.4209L12.4219 11.4573C12.532 11.5698 12.6193 11.7035 12.6788 11.8507C12.7384 11.9978 12.7691 12.1555 12.7691 12.3148C12.7691 12.4741 12.7384 12.6318 12.6788 12.779C12.6193 12.9261 12.532 13.0598 12.4219 13.1724C12.312 13.2851 12.1814 13.3745 12.0378 13.4355C11.8941 13.4965 11.74 13.5279 11.5845 13.5279C11.429 13.5279 11.2749 13.4965 11.1312 13.4355C10.9876 13.3745 10.857 13.2851 10.7471 13.1724L10.7116 13.136C10.5721 12.9963 10.3949 12.9026 10.203 12.8669C10.011 12.8313 9.81298 12.8554 9.63448 12.936C9.45944 13.0129 9.31015 13.1404 9.205 13.303C9.09985 13.4656 9.04342 13.6562 9.04266 13.8512V13.9542C9.04266 14.2757 8.91796 14.584 8.69599 14.8113C8.47402 15.0386 8.17296 15.1663 7.85904 15.1663C7.54512 15.1663 7.24406 15.0386 7.02209 14.8113C6.80012 14.584 6.67541 14.2757 6.67541 13.9542V13.8997C6.67083 13.6991 6.60743 13.5045 6.49344 13.3413C6.37945 13.1781 6.22015 13.0538 6.03626 12.9845C5.85776 12.9038 5.65975 12.8798 5.46777 12.9154C5.27579 12.9511 5.09864 13.0448 4.95916 13.1845L4.92365 13.2209C4.81372 13.3336 4.68318 13.423 4.53949 13.484C4.3958 13.545 4.24178 13.5764 4.08624 13.5764C3.93069 13.5764 3.77667 13.545 3.63298 13.484C3.48929 13.423 3.35875 13.3336 3.24882 13.2209C3.13877 13.1083 3.05147 12.9746 2.9919 12.8275C2.93234 12.6803 2.90168 12.5226 2.90168 12.3633C2.90168 12.204 2.93234 12.0463 2.9919 11.8991C3.05147 11.752 3.13877 11.6183 3.24882 11.5057L3.28433 11.4694C3.42076 11.3265 3.51229 11.1451 3.5471 10.9485C3.58191 10.7519 3.55841 10.5491 3.47963 10.3663C3.40461 10.1871 3.28004 10.0342 3.12126 9.92653C2.96249 9.81885 2.77643 9.76106 2.58599 9.76028H2.48538C2.17147 9.76028 1.87041 9.63258 1.64843 9.40526C1.42646 9.17794 1.30176 8.86963 1.30176 8.54816C1.30176 8.22668 1.42646 7.91838 1.64843 7.69106C1.87041 7.46374 2.17147 7.33604 2.48538 7.33604H2.53865C2.73453 7.33135 2.92451 7.26641 3.08388 7.14968C3.24325 7.03295 3.36465 6.86982 3.43228 6.68149C3.51106 6.4987 3.53456 6.29592 3.49975 6.09932C3.46494 5.90271 3.37342 5.7213 3.23698 5.57846L3.20148 5.5421C3.09143 5.42953 3.00412 5.29584 2.94456 5.14869C2.88499 5.00154 2.85433 4.84381 2.85433 4.68452C2.85433 4.52523 2.88499 4.3675 2.94456 4.22035C3.00412 4.0732 3.09143 3.93952 3.20148 3.82695C3.3114 3.71425 3.44194 3.62484 3.58563 3.56384C3.72932 3.50285 3.88334 3.47145 4.03889 3.47145C4.19444 3.47145 4.34846 3.50285 4.49215 3.56384C4.63584 3.62484 4.76638 3.71425 4.8763 3.82695L4.91181 3.86331C5.05129 4.00303 5.22844 4.09676 5.42042 4.1324C5.6124 4.16805 5.81041 4.14399 5.98891 4.06331H6.03626C6.2113 3.98648 6.36058 3.85892 6.46573 3.69632C6.57088 3.53372 6.62731 3.34318 6.62807 3.14816V3.04513C6.62807 2.72365 6.75277 2.41535 6.97475 2.18803C7.19672 1.96071 7.49778 1.83301 7.81169 1.83301C8.12561 1.83301 8.42667 1.96071 8.64864 2.18803C8.87062 2.41535 8.99532 2.72365 8.99532 3.04513V3.09967C8.99608 3.2947 9.05251 3.48524 9.15766 3.64784C9.26281 3.81044 9.41209 3.938 9.58713 4.01483C9.76563 4.0955 9.96364 4.11957 10.1556 4.08392C10.3476 4.04827 10.5248 3.95455 10.6642 3.81483L10.6997 3.77846C10.8097 3.66576 10.9402 3.57636 11.0839 3.51536C11.2276 3.45436 11.3816 3.42296 11.5372 3.42296C11.6927 3.42296 11.8467 3.45436 11.9904 3.51536C12.1341 3.57636 12.2646 3.66576 12.3746 3.77846C12.4846 3.89104 12.5719 4.02472 12.6315 4.17187C12.6911 4.31902 12.7217 4.47675 12.7217 4.63604C12.7217 4.79533 12.6911 4.95306 12.6315 5.10021C12.5719 5.24736 12.4846 5.38104 12.3746 5.49361L12.3391 5.52998C12.2026 5.67281 12.1111 5.85423 12.0763 6.05083C12.0415 6.24744 12.065 6.45021 12.1438 6.63301V6.68149C12.2188 6.86075 12.3433 7.01362 12.5021 7.12131C12.6609 7.22899 12.847 7.28678 13.0374 7.28755H13.138C13.4519 7.28755 13.753 7.41526 13.975 7.64258C14.1969 7.86989 14.3216 8.1782 14.3216 8.49967C14.3216 8.82115 14.1969 9.12946 13.975 9.35677C13.753 9.58409 13.4519 9.7118 13.138 9.7118H13.0847C12.8943 9.71257 12.7082 9.77036 12.5495 9.87804C12.3907 9.98573 12.2661 10.1386 12.1911 10.3179Z"
					stroke="#646464"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="dull-bright-filter"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1897_11864">
					<rect
						width="15.6238"
						height="16"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
	const purposeOfrequest = ['Agency Banking', 'Merchant Collection'];
	const generateIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="25"
			fill="none"
			viewBox="0 0 24 25"
			className="img"
		>
			<path
				fill="var(--primary-base-color)"
				d="M15.48 2.9H7.53c-3.46 0-5.52 2.06-5.52 5.52v7.95c0 3.46 2.07 5.52 5.52 5.52h7.95c3.46 0 5.52-2.06 5.52-5.52V8.42c0-3.46-2.07-5.52-5.52-5.52"
				opacity="0.4"
			></path>
			<path
				fill="var(--primary-base-color)"
				d="m21.96 19.74-1.63.55c-.45.15-.81.5-.96.96l-.55 1.63c-.47 1.41-2.45 1.38-2.89-.03l-1.85-5.95c-.36-1.18.73-2.28 1.9-1.91l5.96 1.85c1.4.44 1.42 2.43.02 2.9"
			></path>
		</svg>
	);

	useEffect(() => {
		if (merchant_email && Object.keys(settlement_detail_req)?.length < 1) {
			const obj = {
				email: merchant_email,
			};

			dispatch(bankboxAPI?.fetchSettlementRequest(obj));
		}
	}, []);

	useEffect(() => {
		if (merchant_email && Object.keys(settlement_detail_req)?.length > 0) {
			const obj = {
				email: merchant_email,
			};

			setShowActionBar(true);
		}
	}, [settlement_detail_req]);

	// List of tabs

	const handleFetchHistory = async () => {
		try {
			setIsRefreshing(true);

			await dispatch(
				bankboxAPI.fetchSettlementRequest({ email: merchant_email as string })
			);

			const res = await dispatch(
				bankboxAPI.getSingleUserMerchant({ email: merchant_email as string })
			);

			const user = res?.payload;

			if (
				!user?.account_request ||
				Object.keys(user.account_request).length === 0
			) {
				setShowActionBar(false);
			}
		} catch (error) {
			// console.error('Error refreshing merchant data:', error);
		} finally {
			setIsRefreshing(false);
		}
	};
	const [loadingGen, setLoadingGen] = useState(false);
	const handleGenerateAccountNumber = async () => {
		setLoadingGen(true);
		const data = await dispatch(
			bankboxAPI.generateAccountNumberVirtual({}) as any
		);

		if (data.payload.status === 'success') {
			// console.log(data?.payload?.data?.data?.account_number);
			setLoadingGen(false);
			setAssignFormData((prev: any) => ({
				...prev,
				account_num: data?.payload?.data?.data?.account_number,
			}));
		} else {
			setLoadingGen(false);
		}
	};

	const getKeyToignore = () => {
		let val;
		if (autoAssign) {
			if (assignFormData?.device_type?.value === 'virtual_terminal') {
				val = [
					'poseidon_business_email',
					'poseidon_business_name',
					'terminal_id',
					'state',
					'lga',
					'serial_number',
					// 'purpose',
				];
			} else {
				val = [
					'poseidon_business_email',
					'poseidon_business_name',
					'terminal_id',
					'purpose',
					'account_num',
				];
			}
		} else {
			val = [
				'serial_number',
				'poseidon_business_email',
				'poseidon_business_name',
				'purpose',
				'account_num',
			];
		}

		return val;
	};

	return (
		<>
			<DashboardLayout
				actionBarComp={
					<>
						{!loading &&
							Object?.keys(user_merchant)?.length > 0 &&
							Object?.keys(user_merchant?.business_update)?.length > 0 &&
							showActionEditRequest && (
								<RavenActionBar
									visible={
										Object?.keys(user_merchant?.business_update)?.length > 0 &&
										showActionEditRequest
									}
									onAction={() => {
										setIsShowModal((prev) => {
											return {
												...prev,
												business_request: true,
											};
										});
									}}
									msg={
										String(user_merchant?.business_update?.status) === '0'
											? 'Merchant’s Business details was requested to be changed'
											: `Merchant’s Business name details request change has been rejected.`
									}
									// review_notes
									type={
										String(user_merchant?.business_update?.status) === '0'
											? 'warning'
											: 'error'
									}
									onCancel={() => {
										setShowActionEditRequest(false);
									}}
									actionText="View Change Request"
									className="general-actionbar"
								/>
							)}

						<RavenActionBar
							className="general-actionbar "
							actionText="View Request"
							msg="This merchant is requesting a settlement detail change"
							onAction={() => setIsModalOpen(true)}
							onCancel={() => {
								setShowActionBar(false);
							}}
							type={
								String(user_merchant?.account_request?.status) === '0'
									? 'warning'
									: 'error'
							}
							visible={
								!!user_merchant?.account_request &&
								Object.keys(user_merchant.account_request).length > 0 &&
								showActionBar
							}
						/>
					</>
				}
				back
				onBack={() => navigate(ALL_ROUTES?.BANKBOX_USER)}
			>
				<PageLayout
					pageTitle="Merchant Details"
					actionBar={<></>}
					pageSubtitle="All Details about this Merchant"
					topRightContent={
						<>
							<div
								ref={testingFilterFragRef}
								className="settings-icon-drop-box-wrap-merchant-page"
								style={{ gap: '2rem' }}
							>
								<div
									onClick={() => {
										// showManagedropdown && setShowManageDropDown(false);
										setShowDrop(!showDrop);
									}}
									className="icon-box-wrap white-base-black-bg border-theme"
								>
									<figure className="img-box">{settingsIcon}</figure>
								</div>
								{/* drop down icon box sytarrt */}
								{showDrop && (
									<div className="drop-down-icon-box white-base-black-bg border-theme">
										{/* icon text box start */}

										{actionList.map((item, index) => (
											<div
												key={index}
												className="icon-text-box"
												onClick={() => {
													if (item.onClick) {
														item.onClick();
														setShowDrop(false);
													}
												}}
											>
												<div className="icon-img-box">
													<figure className="img-box">{item.icon}</figure>
												</div>
												<p className="text grey-white-color">{item.name}</p>
											</div>
										))}

										{/* icon text box end */}
									</div>
								)}
								{/* drop down icon box end */}
							</div>
						</>
					}
					loading={loading || true}
					noContent={Object?.keys(user_merchant)?.length < 1}
					LoadingText="Loading merchant info.."
				>
					{/* UserDetailsInfo comes first */}
					<UserDetailsInfo
						assignBankbox={assignBankbox}
						setAssignBankbox={setAssignBankbox}
						userDetails={userDetails}
						setViewSettleMent={setShowSettlement}
						setViewFeeDetails={setEditMerchantFeeModal}
						setSingleChild={setSingleChild}
						// setEditMerchantModal={() => {}}
						setRequestSettleMerchantModal={setRequestSettleMerchantModal}
					/>
					<div
						className="com-layout-index-wrap-box"
						style={{
							marginBottom: '1.5rem',
							flex: 'unset',
							overflowY: 'unset',
						}}
					>
						{/* Tabs Navigation */}
						<div className="children-route-wrapper-box white-faded-white-bg -layout non-over-flow-y-div">
							{/* tablink start */}
							<SingleMerchantTabLink
								activeTabIndex={activeTabIndex}
								setActiveTabIndex={setActiveTabIndex}
							/>
							{/* tab link end */}

							{/* Render Active Tab's Content */}
							<div
								// onClick={() => {
								// 	console.log(user_merchant);
								// }}
								className="children-wrap-box"
							>
								{children}
							</div>
						</div>
					</div>
				</PageLayout>{' '}
			</DashboardLayout>

			{/* start here */}
			<>{childrenModal ? childrenModal : ''}</>
			{/* ends here */}

			<ReqAccountModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				onAction={() => {
					//('Go to profile');
					setIsModalOpen(false);
				}}
				requestData={settlement_detail_req}
				onFinish={handleFetchHistory}
			/>

			<RavenModal
				onClose={() => setAssignBankbox({ ...assignBankbox, on: false })}
				visble={assignBankbox.on}
				// visble={true}
				loading={loading}
				onBtnClick={handleAssign}
				btnColor="deep-green-light"
				btnLabel={!uploadViaCamera ? 'Assign Terminal' : ''}
				className={`session-expired-wrap-modal`}
				disabled={
					assignFormData?.device_type?.value === 'virtual_terminal'
						? removeSpace(String(assignFormData?.account_num))?.length < 10 ||
						  RavenValidateData({
								paramOne: { ...assignFormData, ...details },
								ignoreKeys: getKeyToignore(),
						  })
						: RavenValidateData({
								paramOne: { ...assignFormData, ...details },
								ignoreKeys: getKeyToignore(),
						  })
				}
			>
				<div
					// onClick={() => {
					// 	console.log(assignFormData);
					// }}
					className="assign-bb-modal"
				>
					<div className="assign-bb-modal__title">
						<h6>Assign Terminal</h6>
						<p>Allocate a Terminal to a user </p>
					</div>

					{uploadViaCamera ? (
						<>
							{/* <WebcamCapture /> */}
							<CameraAssignBox
								onCancel={() => {
									setUploadViaCamera(false);
								}}
								onFinish={(param: any) => {
									setUploadViaCamera(false);
									setTerminalDetails(param);
									setAssignFormData((prev) => {
										return { ...prev, serial_number: param?.actualValue };
									});
								}}
							/>
						</>
					) : (
						<>
							{' '}
							<div className="assign-bb-modal__form-body">
								<RavenInputField
									style={{
										position: 'relative',
										zIndex: 100,
										padding: '0rem .2rem',
									}}
									type="select"
									value={assignFormData?.device_type}
									onChange={(e: any) => {
										setAssignFormData({
											...assignFormData,
											device_type: e,
										});
									}}
									color="deep-green-light"
									label="Device Type"
									placeholder="E.g Select device type"
									name="device_type"
									menuPlacement={`bottom`}
									selectOption={deviceTypeOption}
									selectStyles={reactSelectStyle}
								/>

								{assignFormData?.device_type?.value === 'virtual_terminal' ? (
									<>
										{' '}
										<RavenInputField
											type="text"
											value={assignFormData?.label}
											onChange={(e: any) => {
												setAssignFormData({
													...assignFormData,
													label: e.target.value,
												});
											}}
											color="deep-green-light"
											label="BankBox Label"
											placeholder="E.g Eatery one"
											name="serial"
										/>
										<div className="prefered-account-type">
											<RavenInputField
												value={assignFormData?.account_num}
												onChange={(e: any) => {
													setAssignFormData((prev: any) => ({
														...prev,
														account_num: e.target.value,
													}));
												}}
												name="accountNo"
												maxLength={10}
												color="deep-green-light"
												label={
													loadingGen
														? 'Generate account number'
														: 'Enter your preferred account no. or generate '
												}
												type="account-number"
												placeholder="e.g 0121559651"
												labelSpanText={
													loadingGen ? (
														<>
															<div
																style={{
																	padding: '0rem',
																	display: 'flex',
																	justifyContent: 'flex-end',
																	transform: 'translateX(1.5rem)',
																}}
																className="load-wrap"
															>
																<ThreeDots
																	height="10"
																	width="80"
																	radius="9"
																	// color="#020202"
																	ariaLabel="three-dots-loading"
																	wrapperStyle={{}}
																	visible={true}
																/>
															</div>
														</>
													) : (
														('' as any)
													)
												}
											/>

											<div
												className="generate-box grey-bg"
												onClick={() => {
													if (!loadingGen) {
														handleGenerateAccountNumber();
													}
												}}
											>
												<figure className="img-box">{generateIcon}</figure>
											</div>
										</div>
										<RavenInputField
											menuPlacement={`top`}
											onChange={(e: any) => {
												setAssignFormData((prev: any) => {
													return { ...prev, purpose: e };
												});
											}}
											color="deep-green-light"
											label="Purpose of request * "
											type="select"
											value={assignFormData?.purpose}
											placeholder="Select option"
											selectOption={formatState(purposeOfrequest)}
											selectStyles={reactSelectStyle}
											style={{
												width: '100%',
												position: 'relative',
												zIndex: 200,
												padding: '0rem .1rem',
											}}
										/>
									</>
								) : (
									<>
										{' '}
										<div className="serial-number-input-form-group">
											<RavenInputField
												type={`account-number`}
												maxLength={10}
												color="deep-green-light"
												value={assignFormData?.serial_number}
												label="BankBox Serial Number"
												onChange={(e: any) => {
													setAssignFormData({
														...assignFormData,
														serial_number: e.target.value,
													});
													if (terminalDetails) {
														setTerminalDetails({});
													}
												}}
												placeholder="Input last 10 digit of serial number"
												name="serial"
												labelSpanText={
													terminalDetails?.fullValue ? (
														((
															<>
																<div
																	onClick={() => {
																		setUploadViaCamera(true);
																	}}
																	className="camera-icon-box"
																>
																	<div className="camera-icon">
																		<figure className="img-box grey-bg">
																			{cameraIcon}
																		</figure>
																	</div>
																	<p>Input via webcam</p>
																</div>
															</>
														) as any)
													) : (
														<div
															onClick={() => {
																setUploadViaCamera(true);
															}}
															className="camera-icon-box"
														>
															<div className="camera-icon">
																<figure className="img-box grey-bg">
																	{cameraIcon}
																</figure>
															</div>
															<p>Input via webcam </p>
														</div>
													)
												}
											/>
										</div>
										<RavenInputField
											type="text"
											value={assignFormData?.label}
											onChange={(e: any) => {
												setAssignFormData({
													...assignFormData,
													label: e.target.value,
												});
											}}
											color="deep-green-light"
											label="BankBox Label"
											placeholder="E.g Eatery one"
											name="serial"
										/>
										{/* two input field box start */}
										<div
											style={{ position: 'relative', zIndex: '101' }}
											className="two-input-field-box"
										>
											<form
												autoComplete="off"
												style={{ width: '100%' }}
												action=""
											>
												<RavenInputField
													menuPlacement={`top`}
													selectStyles={reactSelectStyle}
													color="deep-green-light"
													label="State * "
													type="select"
													placeholder="Select option"
													value={details?.state}
													onChange={(e: any) => {
														setDetails((prev) => {
															return { ...prev, state: e, lga: '' };
														});
														// if
														// dispatch(
														// 	bankboxAPI.getBankboxLgaByStates({ region: e.value })
														// );
													}}
													// disabled={user?.region ? true : false}
													selectOption={formatState(all_states)}
												/>
											</form>
											<form
												autoComplete="off"
												style={{ width: '100%' }}
												action=""
											>
												{' '}
												<RavenInputField
													selectStyles={reactSelectStyle}
													menuPlacement={`top`}
													color="deep-green-light"
													label="City* "
													type="text"
													placeholder="Enter city"
													disabled={!details?.state}
													value={details?.lga}
													onChange={(e: any) => {
														setDetails((prev) => {
															return { ...prev, lga: e?.target?.value };
														});
													}}
													selectOption={formatState(all_lga)}
													// loadingSelect={true}
												/>
											</form>
										</div>
										{/* two input field box end */}
										{/* auto generate box start */}
										<div
											style={{ position: 'relative', zIndex: '20' }}
											className="auto-generate-box-wrap"
										>
											<div className="togle-info-box">
												{' '}
												<RavenToggleSlide
													value={autoAssign}
													checked={autoAssign}
													onChange={() => {
														setAutoAssign(!autoAssign);
													}}
													color={`deep-green-light`}
												/>
											</div>

											<p className="text">Autogenerate Terminal ID</p>
											<div className="info-box">
												<figure className="img-box tooltip-hover-wrap">
													{infoIcon}
													<RavenToolTip
														textColor="white-light"
														color={`deep-green-light`}
														position={`top-left`}
														text="Autogenerate Terminal info"
													/>
												</figure>
											</div>
										</div>
										{/* auto generate box end */}
										{/* auto assin content start */}
										{!autoAssign && (
											<div className="auto-assign-content-box">
												<RavenInputField
													type="text"
													value={assignFormData?.terminal_id}
													showError={showTerminalError}
													onChange={(e: any) => {
														if (e.target.value?.length < 9) {
															setShowTerminalError(false);
															setAssignFormData((prev) => {
																return { ...prev, terminal_id: e.target.value };
															});
														}
													}}
													color="deep-green-light"
													label="Terminal ID"
													placeholder="Enter Terminal ID"
													name="term_id"
													// maxSize={8}
												/>
												{/* select option start  */}
												<div
													className="select-option-box-wrap"
													style={{ marginTop: '2.4rem' }}
												>
													<label htmlFor="">
														Is this Terminal ID registered on NIBSS?
													</label>
													<div
														className={'export-modal__export-as--selector-wrap'}
													>
														{selectTypeList?.map((chi, idx) => {
															return (
																<div
																	key={idx}
																	onClick={() => {
																		setSelectedType(chi);
																		setAssignFormData((prev) => {
																			return {
																				...prev,
																				exist_nibbs:
																					chi === 'Yes, It is' ? true : false,
																			};
																		});
																	}}
																	className={`selector-wrap__item ${
																		selectedType === chi && 'selected'
																	}`}
																>
																	<figure>
																		{selectedType === chi
																			? icons.radio_check
																			: icons.radio_unchecked}
																	</figure>
																	<p>{chi}</p>
																</div>
															);
														})}
													</div>
												</div>
												{/* select option end */}
											</div>
										)}
										{/* auto assin content end */}
									</>
								)}
							</div>
						</>
					)}
				</div>
			</RavenModal>

			<SettleMentAccountModal
				visible={showSettlement}
				onClose={() => {
					setShowSettlement(false);
				}}
			/>

			<EditUserOptionModal
				detail={singleChild}
				onClose={() => {
					setIsShowModal((prev) => {
						return { ...prev, edit_option: false, edit_business: false };
					});
				}}
				fromPersonal={showModal?.edit_business}
				visible={showModal?.edit_option}
				onPersonalEdit={() => {
					setIsShowModal((prev) => {
						return {
							...prev,
							edit_option: false,
							edit_personal: true,
							edit_business: false,
						};
					});
				}}
				onFinish={() => {
					setIsShowModal((prev) => {
						return {
							...prev,
							edit_option: false,
							edit_personal: false,
							edit_business: false,
							business_request: true,
						};
					});
				}}
			/>
			<RavenModal
				visble={showModal?.fee}
				onClose={() => {
					setIsShowModal((prev) => {
						return { ...prev, fee: false };
					});
				}}
				className={'bankbox-create-modal bankbox-create-modal-update-fee'}
				onBtnClick={function (e?: any): void {
					throw new Error('Function not implemented.');
				}}
			>
				<UpdateMerchantFeeUserModal
					onComplete={() => {
						setRefreshTable(!refreshTable);
						setIsShowModal((prev) => {
							return { ...prev, fee: false };
						});
						toast.success('BankBox merchant fee updated successfully');
					}}
					detail={singleChildFee}
					feeDetail={feeDetail}
					setFeeDetail={setFeeDetail}
					visible={showModal.fee}
				/>
			</RavenModal>

			<RavenModal
				visble={showModal?.edit_personal}
				onClose={() => {
					setIsShowModal((prev) => {
						return {
							...prev,
							edit_option: true,
							edit_personal: false,
							edit_business: false,
						};
					});
				}}
				className={'bankbox-create-modal'}
				onBtnClick={function (e?: any): void {
					throw new Error('Function not implemented.');
				}}
			>
				<UpdateBankboxUserModal
					onComplete={() => {
						setRefreshTable(!refreshTable);
						setIsShowModal((prev) => {
							return { ...prev, edit_personal: false, edit_business: false };
						});
						toast.success('BankBox merchant updated successfully');
					}}
					onBusinessEdit={() => {
						setIsShowModal((prev) => {
							return {
								...prev,
								edit_option: true,
								edit_personal: false,
								edit_business: true,
							};
						});
					}}
					detail={singleChild}
					visible={showModal?.edit_personal}
				/>
			</RavenModal>

			<ProccessSettleMentAccountModal
				onClose={() => {
					setRequestSettleMerchantModal(false);
				}}
				el={el}
				visible={requestSettleMerchantModal}
				onFinish={() => {
					setRefreshTable(!refreshTable);
				}}
			/>
			<BusinessRequestChangeModal
				onClose={() => {
					setIsShowModal((prev) => {
						return {
							...prev,
							business_request: false,
						};
					});
				}}
				visible={showModal?.business_request}
				onEdit={() => {
					setIsShowModal((prev) => {
						return {
							...prev,
							edit_option: true,
							edit_personal: false,
							edit_business: true,
							business_request: false,
						};
					});
				}}
			/>
			{modalContent}
		</>
	);
};

export default SingleUserLayout;
